import { render } from "./create.vue?vue&type=template&id=cab2a3a4"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/products/create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cab2a3a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cab2a3a4', __exports__)) {
    console.log('reload')
    api.reload('cab2a3a4', __exports__)
  }
  
  module.hot.accept("./create.vue?vue&type=template&id=cab2a3a4", () => {
    console.log('re-render')
    api.rerender('cab2a3a4', render)
  })

}


export default __exports__